import { Map, Set, fromJS } from 'immutable';
import { RESET_DEFAULT_CLIENT_DATA } from 'checkout/CheckoutRoutes/HotelCheckout/store/domains/client/constants';
import { changeTouristData, clearTouristData } from 'src/store/tourists/slice';
import {
  DELETE_SAVED_TOURIST_FAIL,
  DELETE_SAVED_TOURIST_SUCCESS,
  SET_TOURISTS,
  UPDATE_SAVED_TOURIST,
} from '../client/constants';
import {
  SET_TOURIST_VALIDATED,
  UPDATE_MOCK_TOURIST,
} from '../constants/tourists';
import { CREATE_PACKAGE_SUCCESS } from '../constants/similar-packages';
import { makeMockTourists } from '../../../../utils/mockUtils';

const initialState = Map();

const getValidatedTourists = (state) =>
  state.get('validatedTourists') || new Set();

export default function dataReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_MOCK_TOURIST: {
      const { index, visa_service } = payload;
      const mockTourists = state.get('mockTourists');
      return state.set(
        'mockTourists',
        mockTourists.update(index, (item) =>
          item.set('visa_service', visa_service),
        ),
      );
    }
    case SET_TOURISTS:
      return state.set('tourists', fromJS(action.payload));
    case UPDATE_SAVED_TOURIST: {
      const indexToReplace = state
        .get('tourists')
        .toJS()
        .findIndex((t) => t.id === action.payload.id);

      if (indexToReplace !== -1) {
        return state.setIn(['tourists', indexToReplace], action.payload);
      }

      return state;
    }
    case DELETE_SAVED_TOURIST_SUCCESS: {
      const tourists = state.get('tourists').toJS();

      return state.set(
        'tourists',
        fromJS(tourists.filter((t) => t.id !== action.payload)),
      );
    }
    case DELETE_SAVED_TOURIST_FAIL: {
      if (action.payload !== undefined) {
        const updatedTourists = state
          .get('tourists')
          .update(action.payload, (tourist) => ({
            ...tourist,
            state: 'error',
          }));
        return state.set('tourists', updatedTourists);
      }
      return state;
    }
    case changeTouristData.type: {
      const { index } = action.payload;
      const validatedTourists = getValidatedTourists(state).delete(index);
      return state.set('validatedTourists', validatedTourists);
    }
    case SET_TOURIST_VALIDATED: {
      const { payload: index } = action;
      const validatedTourists = getValidatedTourists(state).add(index);
      return state.set('validatedTourists', validatedTourists);
    }
    case CREATE_PACKAGE_SUCCESS:
      return state.merge(
        fromJS({
          mockTourists: makeMockTourists(payload),
        }),
      );
    case clearTouristData.type:
      return state.set('validatedTourists', new Set());
    case RESET_DEFAULT_CLIENT_DATA:
      return state.set('resetDefaultClientData', action.payload);
    default:
      return state;
  }
}
